import React from 'react'

export default function FormSignIn(props) {
    const { buttonHandler, inputHandler} = props
    return (
        <div>
            <form 
            className="d-flex flex-column p-5"
            onSubmit={ e => e.preventDefault()}>
                <h2
                    className="title-form"
                >Welcome to DEV Community</h2>
                <label 
                    className="input-labels mt-3" 
                    htmlFor="name">Name
                </label>
                <input 
                    className=""
                    name="name"
                    type="text"
                    onChange={inputHandler}
                />
                <label 
                    className="input-labels mt-3" 
                    htmlFor="bio">Bio
                </label>
                <textarea 
                    name="bio"
                    onChange={inputHandler}
                ></textarea>
                <label 
                    className="input-labels mt-3" 
                    htmlFor="education">Education
                </label>
                <input 
                    className=""
                    name="education"
                    type="text"
                    onChange={inputHandler}
                />
                <label 
                    className="input-labels mt-3" 
                    htmlFor="location">Location
                </label>
                <input 
                    className=""
                    name="location"
                    type="text"
                    onChange={inputHandler}
                />
                <label 
                    className="input-labels mt-3" 
                    htmlFor="username">Username
                </label>
                <input 
                    type="text" 
                    name="username"
                    onChange={inputHandler}
                />
                <label 
                    className="input-labels mt-3" 
                    htmlFor="email">Email
                </label>
                <input
                    type="text"
                    name="email"
                    onChange={inputHandler}
                />
                <label 
                    className="input-labels mt-3" 
                    htmlFor="password">Password
                </label>
                <input
                    type="text"
                    name="password"
                    onChange={inputHandler}
                />
                <button 
                    className="mt-4 rounded text-white sign-in-btn p-2" 
                    onClick={buttonHandler}
                    > Sign In 
                </button>
            </form>
        </div>
    )
}
